import * as React from 'react';
import { FilterProps } from '../filters';
import './seriesFilter.scss';
import { Op } from '../../../enums/Op';
import { parseCondition } from '../../../utils';
import { Typeahead } from '../../Typeahead/typeahead';

const Booleans = ['True', 'False'];

export const SeriesFilter = ({ filter, setFilter }: FilterProps) => {
  const curFilter = filter;
  const { op, val } = parseCondition(curFilter.conditions, Op.isNotEmpty);

  const getValue = () => {
    if (!curFilter.conditions?.length) return '';
    if (op === Op.isNotEmpty && val === true) return 'True';
    if (op === Op.isEmpty && val === true) return 'False';
    return '';
  };

  return (
    <div className="filter-box boolean-filter">
      <div>Is in a Series&nbsp;</div>
      <div>
        <Typeahead
          value={getValue()}
          options={Booleans}
          showAllByDefault
          includes={() => true}
          onSelect={o =>
            setFilter({
              ...curFilter,
              conditions: [
                { [o === 'True' ? Op.isNotEmpty : Op.isEmpty]: true }
              ]
            })
          }
          onTextChange={t => {
            if (!t) {
              setFilter({ ...curFilter, conditions: [] });
            } else if (t?.toLowerCase() === 'true') {
              setFilter({
                ...curFilter,
                conditions: [{ [Op.isNotEmpty]: true }]
              });
            } else if (t?.toLowerCase() === 'false') {
              setFilter({ ...curFilter, conditions: [{ [Op.isEmpty]: true }] });
            }
          }}
        />
      </div>
    </div>
  );
};
